import styled from '@emotion/styled'
import { css } from '@emotion/react'

const Container = styled.header`
  --size: ${({ theme }) => theme.size.height[500]};

  & {
    height: var(--size);
    touch-action: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: ${({ theme }) => theme.colors.gray[0]};
    box-shadow: inset -1px -1px 0 0 ${({ theme }) => theme.colors.gray[300]};
  }

  .container {
    height: var(--size);
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    flex-flow: row nowrap;
    margin: 0 auto;
    background-color: ${({ theme }) => theme.colors.gray[0]};
    top: 0;
    left: 0;
    right: 0;
    position: absolute;
    z-index: 10;
  }

  .menu-container {
    display: flex;
    justify-content: center;
    align-items: stretch;
    flex-flow: row nowrap;
    height: 100%;
    z-index: 10;
  }

  .facebook-share-button-container-inlist {
    width: 100%;
    margin: 0;
  }

  .facebook-share-button-container {
    margin: 0;
  }

  .hamburgur,
  .facebook-share-button-inlist,
  .facebook-share-button,
  .phone-button-inlist,
  .phone-button {
    cursor: pointer;
    border: none;
    color: ${({ theme }) => theme.colors.gray[0]};
    background-color: ${({ theme }) => theme.colors.facebook[400]};
    width: var(--size);
    height: var(--size);
    display: flex;
    justify-content: center;
    margin: 0;
    align-items: center;
    transition: ${({ theme }) => theme.style.transitionTime[400]} opacity;
  }

  .phone-button {
    background-color: ${({ theme }) => theme.colors.gray[0]};
    color: ${({ theme }) => theme.colors.gray[700]};
    box-shadow: inset 0px -1px 0 0 ${({ theme }) => theme.colors.gray[300]};
  }

  .phone-button:hover {
    opacity: ${({ theme }) => theme.style.opacity[700]};
  }

  .phone-button:focus {
    opacity: ${({ theme }) => theme.style.opacity[500]};
  }

  .facebook-share-button:hover {
    opacity: ${({ theme }) => theme.style.opacity[700]};
  }

  .facebook-share-button:focus {
    opacity: ${({ theme }) => theme.style.opacity[500]};
  }

  .phone-button-inlist,
  .facebook-share-button-inlist {
    transition: ${({ theme }) => theme.style.transitionTime[400]}
        background-color,
      ${({ theme }) => theme.style.transitionTime[400]} color;
    color: ${({ theme }) => theme.colors.gray[0]};
    background-color: transparent;
    width: 100%;
    height: var(--size);
  }

  .facebook-share-button-inlist:hover {
    background-color: ${({ theme }) => theme.colors.primary[400]};
  }

  .facebook-share-button-inlist:focus {
    background-color: ${({ theme }) => theme.colors.primary[600]};
  }

  .facebook-share-button-inlist:active {
    background-color: ${({ theme }) => theme.colors.primary[600]};
  }

  .hamburgur {
    transition: ${({ theme }) => theme.style.transitionTime[400]} color,
      ${({ theme }) => theme.style.transitionTime[400]} background-color;
    color: ${({ theme }) => theme.colors.secondary[900]};
    background-color: transparent;
  }

  .hamburgur.pressed,
  .hamburgur:hover {
    color: ${({ theme }) => theme.colors.gray[0]};
    background-color: ${({ theme }) => theme.colors.secondary[900]};
  }

  .hamburgur:focus {
    color: ${({ theme }) => theme.colors.gray[0]};
    background-color: ${({ theme }) => theme.colors.secondary[1000]};
  }

  .background {
    background-color: ${({ theme }) => theme.colors.gray[920]};
    box-shadow: 0 2px 6px 0 ${({ theme }) => theme.colors.gray[100]}7F;
    opacity: 0.79;
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 8;
  }

  .menu-list {
    position: fixed;
    top: var(--size);
    left: 0;
    right: 0;
    background-color: ${({ theme }) => theme.colors.secondary[900]};
    z-index: 10;
    overflow: hidden;
    box-shadow: 0 2px 6px 0 ${({ theme }) => theme.colors.gray[1000]}7f;
  }

  .logo {
    margin: 0 0 0 16px;
    height: 100%;
    cursor: pointer;
    transition: ${({ theme }) => theme.style.transitionTime[400]} opacity;
  }

  .logo > svg {
    height: var(--size);
  }

  .logo:hover {
    opacity: ${({ theme }) => theme.style.opacity[700]};
  }

  .logo:focus {
    opacity: ${({ theme }) => theme.style.opacity[500]};
  }

  ${({ theme }) =>
    css(
      theme.size.mq({
        '--size': [
          theme.size.height[400],
          theme.size.height[400],
          theme.size.height[400],
          theme.size.height[500],
        ],
        '.hamburgur': {
          display: ['flex', 'flex', 'flex', 'none'],
        },
        '.menu-container': {
          display: ['none', 'none', 'none', 'flex'],
        },
        nav: {
          maxWidth: ['unset', 'unset', 'unset', 'unset', 'unset', '1500px'],
        },
      }),
    ).styles}
`

export default Container
